import { login } from '@bilibili-maoer/web-utils'

import { Middleware, isRejectedWithValue } from '@reduxjs/toolkit'
import { P, match } from 'ts-pattern'

import SystemSlice from '~/core/slices/system'
import { noop } from '~/core/utils/noop'

/**
 * TODO: 迁移到 @bilibili-maoer/web-utils
 */
export enum EErrorCode {
  /**
   * 需要登录
   */
  LoginRequired = 100010006,
  /**
   * 用户未绑定手机
   */
  UserNotBindPhone = 500020013,
  /**
   * 需要公会身份验证
   */
  GuildIdentifyVerificationRequired = 500020027,
  /**
   * 公会已经发起邀请
   */
  GuildAlreadyInvite = 500050009,
  /**
   * 无权执行该操作
   */
  NoPermission = 501010003,
  /**
   * 验证码错误
   */
  IdentifyCodeError = 501010006,
}

/**
 * error 弹窗的黑名单
 * 存放不需要 error 弹窗的接口请求方法
 */
const ERROR_BLACK_LIST = ['getGuildLiveProfitList']

export const errorHandling: Middleware = (api) => (next) => (action) => {
  const pushErrorInfo = ({ info }: { info: string }) => {
    api.dispatch(SystemSlice.actions.pushError(info))
  }

  const pushUnknownError = () => {
    api.dispatch(SystemSlice.actions.pushError('未知错误'))
  }

  const gotoLogin = () => {
    login.gotoLogin()
  }

  if (isRejectedWithValue(action) && !ERROR_BLACK_LIST.includes(action.meta.arg.endpointName)) {
    match(action)
      .with(
        { payload: P.select({ status: P.optional(P.number), data: { code: P.number, info: P.string } }) },
        ({ status, data: { code, info } }) =>
          match({ status, code, info })
            .with({ code: 0 }, noop)
            .with({ code: EErrorCode.LoginRequired }, gotoLogin)
            .with({ code: EErrorCode.NoPermission }, pushErrorInfo)
            .otherwise(pushErrorInfo)
      )
      .otherwise(pushUnknownError)
  }
  next(action)
}
